<template>
  <div class="main">
    <div class="row m-2">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <router-link class="btn btn-info" :to="`/dashboard/create-charge`">
          Create Charge
        </router-link>
        <div class="p-4 col-12">
          <button class="btn btn-info" @click="refresh('refresh')">
            Refresh
          </button>
        </div>
      </div>

      <div class="spinner-grow" role="status" v-if="loading === true"></div>
      <div class="alert alert-danger" role="alert" v-if="error === true">
        {{ errorMsg }}
      </div>
      <!-- <h4>Transactions</h4> -->

      <div class="col-12">
        <card class="card-plain">
          <div class="table-full-width table-responsive">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th scope="col" class="text-center">S/N</th>
                  <th scope="col" class="text-center">Product</th>
                  <th scope="col" class="text-center">Type</th>
                  <th scope="col" class="text-center">Min Amount</th>
                  <th scope="col" class="text-center">Max Amount</th>
                  <th scope="col" class="text-center">Mode</th>
                  <th scope="col" class="text-center">Fee</th>
                  <th scope="col" class="text-center">VAT on Fee (%)</th>
                  <th scope="col" class="text-center">Total Fee</th>
                  <th scope="col" class="text-center">Agent Category</th>
                  <th scope="col" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(charge, index) in charges" :key="charge._id">
                  <th class="text-center">
                    {{ index + 1 }}
                  </th>
                  <td class="text-center">{{ charge.product }}</td>
                  <td class="text-center">{{ charge.type }}</td>
                  <td class="text-center">
                    {{ format.format(charge.minAmount || 0) }}
                  </td>
                  <td class="text-center">
                    {{ format.format(charge.maxAmount || 0) }}
                  </td>
                  <td class="text-center">{{ charge.mode }}</td>
                  <td class="text-center">{{ charge.fee }}</td>
                  <td class="text-center">
                    {{ charge.vat || "N/A" }}
                  </td>
                  <td class="text-center">
                    {{
                      charge.mode === "percentage"
                        ? "--"
                        : charge.totalCharge
                        ? charge.totalCharge
                        : "--"
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      charge.merchantId ? charge.merchantId.merchantName : "--"
                    }}
                  </td>
                  <td class="text-center">
                    <drop-down
                      class="nav-item"
                      title="Options"
                      id="list"
                      :is-open="charge.isDropdownOpen"
                      @change="toggleDropdown(charge._id)"
                    >
                      <div class="p-2">
                        <router-link :to="`/dashboard/charge/${charge._id}`">
                          View charge
                        </router-link>
                      </div>
                    </drop-down>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../store/axios";
import { mapActions } from "vuex";
import DropDown from "../components/multiDropDown.vue";

export default {
  components: { DropDown },
  data() {
    return {
      error: false,
      errorMsg: "",
      loading: false,
      charges: [],
      format: new Intl.NumberFormat("en-US"),
    };
  },
  methods: {
    ...mapActions(["setNotification"]),
    toggleDropdown(id) {
      this.charges = this.charges.map((charge) => {
        if (charge._id === id) {
          charge.isDropdownOpen = !charge.isDropdownOpen;
        } else {
          charge.isDropdownOpen = false;
        }
        return charge;
      });
    },

    async refresh() {
      this.loading = true;
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/charges`);
        const { charges, message } = res.data;
        this.charges = charges;
        this.charges = charges.map((charge) => ({
          ...charge,
          isDropdownOpen: false,
        }));
        this.setNotification({
          type: "success",
          message,
        });
      } catch (error) {
        if (error.response && error.response.data) {
          const { message } = error.response.data;
          this.setNotification({ type: "danger", message });
        } else {
          this.setNotification({
            type: "danger",
            message: "Unable to Fetch Charges",
          });
        }
      }
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    try {
      const res = await axios.get(`${process.env.VUE_APP_API_URL}/charges`);
      const { charges, message } = res.data;
      this.charges = charges;
      this.charges = charges.map((charge) => ({
        ...charge,
        isDropdownOpen: false,
      }));
      this.setNotification({
        type: "success",
        message,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        const { message } = error.response.data;
        this.setNotification({ type: "danger", message });
      } else {
        this.setNotification({
          type: "danger",
          message: "Unable to Fetch Charges",
        });
      }
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
#list {
  list-style-type: none;
}
tbody {
  background: #fff !important;
}
.list {
  list-style-type: none;
}
</style>
